import { render, staticRenderFns } from "./SectionSubTitle.vue?vue&type=template&id=bddc14e2&scoped=true"
import script from "./SectionSubTitle.vue?vue&type=script&lang=js"
export * from "./SectionSubTitle.vue?vue&type=script&lang=js"
import style0 from "./SectionSubTitle.vue?vue&type=style&index=0&id=bddc14e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddc14e2",
  null
  
)

export default component.exports